import { giftCardItem, giftCardRoute } from "@/utils/giftCardUtils";
import getMerchantDetails from "@/dataLayer/getMerchantDetails";
import getItemDetails from "@/dataLayer/getItemDetails";

const ITEM_ID_LENGTH = 13;
const itemIdRegexPattern = `^[A-Z0-9]{${ITEM_ID_LENGTH}}$`;
export const itemIdRegex = new RegExp(itemIdRegexPattern);

export const slugifyName = (name: string): string => {
  if (!name) {
    return "";
  }

  // Replace whitespace with a single hyphen
  let slug = name.trim().replace(/\s+/g, "-");

  // Normalize any accented characters and remove non-url safe characters
  slug = slug
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Remove combining diacritical marks
    .replace(/[^a-zA-Z0-9-]/g, ""); // Remove remaining non-latin/special characters

  // Convert to lowercase
  slug = slug.toLowerCase();

  // Replace multiple consecutive hyphens with a single one
  slug = slug.replace(/-+/g, "-");

  // Remove any leading or trailing hyphens
  slug = slug.replace(/^-+|-+$/g, "");

  return slug;
};

export const getItemId = (slug: string) => {
  const decodedSlug = decodeURIComponent(slug);
  let parts;
  if (!decodedSlug.includes("-") && decodedSlug.includes("/")) {
    parts = decodedSlug.split("/");
    return parts[parts.length - 1];
  }
  parts = decodedSlug.split("-");
  return parts[parts.length - 1];
};

export const getItemUrl = (item: any) => {
  if (item.id === giftCardItem.id) {
    return giftCardRoute;
  }

  if (item.items?.length > 0) {
    item = item.items[0];
  }

  if (item.itemUrl) {
    const parts = item.itemUrl.split("/");
    return encodeURIComponent(`${parts[parts.length - 1]}`);
  }

  return slugifyName(item.name)
    ? encodeURIComponent(`${slugifyName(item.name)}-${item.id}`)
    : item.id;
};

export const getItemUrlById = async (itemId: string) => {
  if (itemId === giftCardItem.id) {
    return giftCardRoute;
  }
  if (!itemIdRegex.test(itemId)) {
    return null;
  }

  const merchant = await getMerchantDetails();
  let item = await getItemDetails(merchant.id, itemId);

  if (item.items?.length > 0) {
    item = item.items[0] as any;
  }

  if (item.itemUrl) {
    const parts = item.itemUrl.split("/");
    return encodeURIComponent(`${parts[parts.length - 1]}`);
  }

  return slugifyName(item.name)
    ? encodeURIComponent(`${slugifyName(item.name)}-${itemId}`)
    : itemId;
};
